module.exports = __webpack_public_path__ + "static/media/logout.4fad7c06.svg";